import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Avatar from "@material-ui/core/Avatar";
import Box from "@material-ui/core/Box";
import Chip from "@material-ui/core/Chip";
import Paper from "@material-ui/core/Paper";
import IconButton from "@material-ui/core/IconButton";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import ImportantDevicesIcon from "@material-ui/icons/ImportantDevices";
import SupervisorAccountIcon from "@material-ui/icons/SupervisorAccount";
import PersonIcon from "@material-ui/icons/Person";
import BuildIcon from "@material-ui/icons/Build";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";
import { useDispatch } from "react-redux";
import { OAuth as OAuthActions } from "../../js/actions";

const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: "#fff",
    borderRadius: 12,
    border: "1px solid #E5E7EB",
    overflow: "hidden",
  },

  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "16px 20px",
    borderBottom: "1px solid #E5E7EB",
  },

  dialogTitleLeft: {
    display: "flex",
    alignItems: "center",
  },

  dialogIconBox: {
    width: 40,
    height: 40,
    borderRadius: 8,
    background: "linear-gradient(135deg, #1a56db 0%, #1e40af 100%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: 12,
  },

  closeButton: {
    color: "#6B7280",
  },

  tableHeadRow: {
    backgroundColor: "#F9FAFB",
  },

  tableHeadCell: {
    fontWeight: 600,
    fontSize: 14,
    color: "#374151",
    borderBottom: "1px solid #E5E7EB",
  },

  tableCell: {
    borderBottom: "1px solid #F3F4F6",
    paddingTop: 14,
    paddingBottom: 14,
  },

  roleTitleCell: {
    display: "flex",
    alignItems: "center",
  },

  roleAvatar: {
    width: 36,
    height: 36,
    backgroundColor: "#1e40af",
    marginRight: 12,
  },

  activeStatusChip: {
    backgroundColor: "#DCFCE7",
    color: "#166534",
    fontWeight: 500,
    height: 28,
    width: 100,

    "& .MuiChip-icon": {
      color: "#166534",
    },
  },

  inactiveStatusChip: {
    backgroundColor: "#FEE2E2",
    color: "#B91C1C",
    fontWeight: 500,
    height: 28,
    width: 100,

    "& .MuiChip-icon": {
      color: "#B91C1C",
    },
  },
}));

const ManageUsers = ({ onClose }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [dataSet, setDataSet] = useState([]);

  useEffect(() => {
    const fetchRoles = async () => {
      await dispatch(OAuthActions.getRole()).then((roleDetails) => {
        const roles = roleDetails.map((item) => ({
          userName: item.name,
          description: item.description,
          status: 1,
        }));

        setDataSet(roles);
      });
    };

    fetchRoles();
  }, [dispatch]);

  const getRoleIcon = (roleName) => {
    if (roleName.includes("Super Admin")) {
      return ImportantDevicesIcon;
    }

    if (
      roleName.includes("Admin") &&
      !roleName.includes("Super Admin")
    ) {
      return SupervisorAccountIcon;
    }

    if (roleName.includes("Analyst")) {
      return PersonIcon;
    }

    if (roleName.includes("Technician")) {
      return BuildIcon;
    }

    return PersonIcon;
  };

  return (
    <div className={classes.root}>
      <Box className={classes.header}>
        <Box className={classes.dialogTitleLeft}>
          <Box className={classes.dialogIconBox}>
            <VerifiedUserIcon
              style={{
                fontSize: 20,
                color: "#fff",
              }}
            />
          </Box>

          <Typography variant="subtitle1">
            <strong>Roles</strong>
          </Typography>
        </Box>

        <IconButton
          size="small"
          onClick={onClose}
          className={classes.closeButton}
        >
          <CloseIcon />
        </IconButton>
      </Box>

      <TableContainer component={Paper} elevation={0}>
        <Table>
          <TableHead>
            <TableRow className={classes.tableHeadRow}>
              <TableCell className={classes.tableHeadCell}>
                Role Title
              </TableCell>

              <TableCell className={classes.tableHeadCell}>
                Role Description
              </TableCell>

              <TableCell className={classes.tableHeadCell}>
                Status
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {dataSet.map((role, index) => {
              const Icon = getRoleIcon(role.userName);

              return (
                <TableRow key={index} hover>
                  <TableCell className={classes.tableCell}>
                    <Box className={classes.roleTitleCell}>
                      <Avatar className={classes.roleAvatar}>
                        <Icon
                          style={{
                            fontSize: 18,
                            color: "#fff",
                          }}
                        />
                      </Avatar>

                      <Typography variant="body2">
                        {role.userName}
                      </Typography>
                    </Box>
                  </TableCell>

                  <TableCell className={classes.tableCell}>
                    <Typography variant="body2">
                      {role.description}
                    </Typography>
                  </TableCell>

                  <TableCell className={classes.tableCell}>
                    <Chip
                      size="small"
                      icon={
                        role.status === 1 ? (
                          <CheckIcon style={{ fontSize: 12 }} />
                        ) : (
                          <CloseIcon style={{ fontSize: 12 }} />
                        )
                      }
                      label={
                        role.status === 1
                          ? "Activated"
                          : "Deactivated"
                      }
                      className={
                        role.status === 1
                          ? classes.activeStatusChip
                          : classes.inactiveStatusChip
                      }
                    />
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default ManageUsers;